import styled from "styled-components";

type Colors = { $background: string; $foreground: string };

/** The card: the shape of a pass on a phone, in the colors of the theme of the Keepo. */
export const Card = styled.figure<Colors>`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 320px;
  aspect-ratio: 320 / 440;
  margin: 0 auto;
  padding: 24px;
  border-radius: 20px;
  background-color: ${props => props.$background};
  color: ${props => props.$foreground};
  font-family: Inter, sans-serif;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35);

  .logo {
    display: flex;
    align-self: flex-start;
    height: 28px;

    /* Keepo's logo in the color of the letters of the card */
    /* the width of the drawing (131 × 42), else the round "o" at its edge gets cut */
    svg {
      width: calc(28px * 131 / 42);
      height: 28px;
      overflow: visible;
    }

    svg path {
      fill: currentColor;
    }
  }

  .photo {
    display: grid;
    place-content: center;
    width: 72px;
    height: 72px;
    margin-top: 20px;
    border-radius: 50%;
    background: color-mix(in srgb, currentColor 20%, transparent);
    box-shadow: 0 0 0 4px color-mix(in srgb, currentColor 25%, transparent);
    object-fit: cover;
    font:
      700 26px Poppins,
      sans-serif;
    text-transform: uppercase;
  }

  .name {
    margin: 14px 0 0;
    font:
      700 22px/28px Poppins,
      sans-serif;
    overflow-wrap: anywhere;
  }

  .role {
    margin: 2px 0 0;
    font-size: 14px;
    line-height: 20px;
    opacity: 0.75;
    overflow-wrap: anywhere;
  }

  .qr {
    display: grid;
    place-content: center;
    width: 132px;
    height: 132px;
    margin-top: auto;
    padding: 10px;
    border-radius: 14px;
    background: #fff;

    svg {
      width: 112px;
      height: 112px;
    }
  }

  /* the address stays at the bottom; the QR, a little above it */
  .url {
    margin-top: 20px;
    font-size: 13px;
    font-weight: 600;
    opacity: 0.85;
  }
`;
